import { useMutation } from "react-query";
import { addOfficeDepartment } from "../../../../../actions/Utilities/OfficeDepartment";

const useAddOfficeDepartment = () => {
  return useMutation(addOfficeDepartment);
};
export default useAddOfficeDepartment;
